<template>
  <div class="box flex-between">
    <div class="flex">
        <div class="line"></div>
        <div class="title">{{title}}</div>
    </div>
    <div class="flex more" @click="toNextPage">
        <div>更多</div>
        <i class="el-icon-d-arrow-right more-icon"></i>
    </div>
  </div>
</template>

<script>
export default {
    name:'sectionTitle',
    props:{
        title:{
            type:String,
            default:''
        },
        link:{
            type:Object,
            default:()=>{
                return {}
            }
        },
    },
    methods:{
        toNextPage(){
            if(this.link){
                this.$router.push(this.link)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.box{
    background: #f3f1ef;
    font-size: 24px;
    color: #666666;
    .title{
        font-size: 26px;
        color: #2c2b29;
        font-weight: bold;
    }
    .more-icon{
        margin-right: 20px;
    }
    .more{
        cursor: pointer;
    }
}
.line{
    width: 12px;
    height: 52px;
    background: #ed9d26;
    margin-right:24px;
}
</style>